import React, { useState } from "react";
import MDSnackbar from "./MDSnackbar";

export default function AlertMessage() {
  const [state, setState] = useState({
    type: "success", // success | warning | error
    title: "Info",
    content: "",
    icon: "check",
    open: false,
  });

  const onClose = () => {
    setState({ ...state, open: false });
  };

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return "check";
      case "warning":
        return "star";
      case "error":
        return "warning";
      default:
        return "";
    }
  };

  const showAlert = (title, content, type = "success") => {
    setState({
      ...state,
      title: title,
      content: content,
      type: type,
      open: true,
      icon: getIcon(type),
    });
  };
  global.showAlert = showAlert;

  return (
    <MDSnackbar
      color={state.type}
      icon={state.icon}
      title={state.title}
      content={state.content}
      dateTime=""
      open={state.open}
      onClose={onClose}
      close={onClose}
      bgWhite
    />
  );
}
